if (!customElements.get('product-tile')) {
  class ProductTile extends HTMLElement {
    constructor() {
      super();
      // Create an initial, paused timeline instance
      this.tl = new TimelineLite({ paused: true });
    }
    
    connectedCallback() {
      // Build the initial animation
      this.initAnimation();

      // Play/reverse on hover
      this.addEventListener('mouseover', () => this.tl.play());
      this.addEventListener('mouseout',  () => this.tl.reverse());

      // On resize, kill the existing timeline and rebuild it
      window.addEventListener('resize', () => this.resetAnimation());

      if (window.location.pathname === '/search') {
        const anchor = this.querySelector(`[data-url]`);
        if (anchor) anchor.href = this.dataset.searchUrl;
      }
    }

    resetAnimation() {
      // Remove any existing tweens and then build a brand-new timeline
      if (this.tl) {
        this.tl.kill();
      }
      this.tl = new TimelineLite({ paused: true });
      this.initAnimation();
    }

    initAnimation() {
      // Select all of the pieces once per build
      const kids          = this.querySelectorAll('*:not(.prod-badge):not(.cta):not(.cta *)');
      const badges        = this.querySelectorAll('.prod-badge');
      const cta           = this.querySelectorAll('.cta > *');
      const featuredImage = this.querySelector('[data-featured_image]');
      const hoverImage    = this.querySelector('[data-hover_image]');
      const shadowSlice   = this.querySelector('[data-shadow-slice]');

      const animationLength = 0.25;
      
      // Base background + badge/text/tween
      this.tl
        .to(this, animationLength, {
          background: 'linear-gradient(180deg, #28485F 0%, #24243F 100%)'
        }, '<')
        .to(shadowSlice, animationLength * (3/5), {
          opacity: 1,
          scale: 1
        }, '<')
        .to(badges, animationLength * (3/5), {
          background: '#FFFFFF',
          color: '#051C2C',
          ease: 'cubic-bezier(0.45, 0.01, 0.07, 1.01)'
        }, '<')
        .to(kids, animationLength * (3/5), {
          color: '#FFFFFF',
          ease: 'cubic-bezier(0.45, 0.01, 0.07, 1.01)'
        }, '<')
        .to(cta, animationLength * (3/5), {
          transform: 'translateX(48px)'
        }, '<');

      // Only swap/blur images on desktop (min-width: 768px)
      if (
        hoverImage &&
        featuredImage &&
        window.matchMedia('(min-width: 768px)').matches
      ) {
        this.tl
          .fromTo(
            featuredImage,
            animationLength,
            { opacity: 1, filter: 'blur(0)' },
            { opacity: 0, filter: 'blur(5px)' },
            '<'
          )
          .fromTo(
            hoverImage,
            0.1,
            { opacity: 0 },
            { opacity: 1 },
            '<'
          )
          .fromTo(
            featuredImage,
            animationLength,
            {
              transform: 'translateX(0) translateY(0) rotate(0)',
              ease: 'cubic-bezier(0.45, 0.01, 0.07, 1.01)'
            },
            {
              transform: 'translateX(1%) translateY(-6%) rotate(14deg) rotateY(-10deg)',
              ease: 'cubic-bezier(0.45, 0.01, 0.07, 1.01)'
            },
            '<'
          )
          .fromTo(
            hoverImage,
            animationLength,
            {
              transform: 'translateX(-2%) translateY(1%) rotate(-13deg)',
              ease: 'cubic-bezier(0.45, 0.01, 0.07, 1.01)'
            },
            {
              transform: 'translateX(1%) translateY(-6%) rotate(0deg)',
              ease: 'cubic-bezier(0.45, 0.01, 0.07, 1.01)'
            },
            '<'
          );
      }
    }
  }

  customElements.define('product-tile', ProductTile);
}
